export default __webpack_public_path__ + "static/media/bannerImage.7354e29b.png";